import { useWizard } from 'react-use-wizard';
import { AnimatedStep } from '../AnimatedStep';
import type { SetupData } from '../SetupWizard';

interface Props {
  data: SetupData;
  updateData: (updates: Partial<SetupData>) => void;
}

export function NameStep({ data, updateData }: Props) {
  const { nextStep, previousStep } = useWizard();

  const canContinue = data.name.trim().length > 0;

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && canContinue) {
      nextStep();
    }
  };

  return (
    <AnimatedStep>
      <div className="space-y-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            What's your name?
          </h2>
          <p className="text-gray-600">
            We'll use this to personalize your experience.
          </p>
        </div>

        <input
          type="text"
          value={data.name}
          onChange={(e) => updateData({ name: e.target.value })}
          onKeyDown={handleKeyDown}
          placeholder="Enter your name"
          autoFocus
          className="w-full px-4 py-4 text-xl border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-0 outline-none transition-colors"
        />

        <div className="flex gap-3">
          <button
            onClick={() => previousStep()}
            className="px-6 py-3 text-gray-600 font-medium hover:text-gray-900 transition-colors"
          >
            Back
          </button>
          <button
            onClick={() => nextStep()}
            disabled={!canContinue}
            className="flex-1 px-6 py-3 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            Continue
          </button>
        </div>
      </div>
    </AnimatedStep>
  );
}
